<template>
  <div
    class="d-flex flex-column align-center justify-center text-center"
    :class="`py-${py}`"
  >
    <v-progress-circular :size="size" :color="color" indeterminate />

    <div v-if="label" class="mt-6 neutral8--text text-body-1">
      {{ label }}
    </div>
  </div>
</template>

<script>
export default {
  name: "Loader",

  props: {
    size: {
      type: [String, Number],
      default: "42",
    },

    color: {
      type: String,
      default: "primary",
    },

    label: {
      type: String,
      default: "",
    },

    py: {
      type: String,
      default: "4",
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
